// extracted by mini-css-extract-plugin
module.exports = {"bold":"Content_bold__3IM-T","icon":"Content_icon__yfAaE","text":"Content_text__aoDq5","spin":"Content_spin__2DreC","transition-opacity":"Content_transition-opacity__Pnq1S"};